var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.704,
    height: 20.894,
    viewBox: "0 0 17.704 20.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M2,20.894A2,2,0,0,1,.005,18.752L.852,6.894h4v-3h0a4,4,0,0,1,8,0h0v3h4L17.7,18.752a2,2,0,0,1-2,2.142ZM1,18.823a1,1,0,0,0,1,1.071H15.7a1,1,0,0,0,1-1.071l-.78-10.929H12.852V9.916h-1V7.894h-6V9.916h-1V7.894H1.783ZM11.852,6.894V4a3,3,0,0,0-6,0V6.894Z",
    transform: "translate(0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion4);
export default __webpack_public_path__ + "static/media/Union 4.d757af1bcfef8a531afd29cc623e2a3b.svg";
export { ForwardRef as ReactComponent };